import {DateTime} from "./models";
import {requireNum, requireStr} from "./utils";

export class UsrMsg {
    public constructor(public guid: string, public msgType: String, public grpId: String, public toPerson: string,
                       public msgJson: any, public status: number, public created: DateTime, public updated: DateTime) {
    }

    static fromJson(json: any) {
        const guid = requireStr(json.guid);
        const msgType = requireStr(json.msgType);
        const grpId = requireStr(json.grpId);
        const toPerson = requireStr(json.toPerson);
        const status = requireNum(json.status);
        const created = DateTime.fromJson(json.created);
        const updated = DateTime.fromJson(json.updated);
        return new UsrMsg(guid, msgType, grpId, toPerson, json.msgJson, status, created, updated);
    }

    get d() {
        return this.msgJson;
    }

    get isRead() {
        return this.status > 0;
    }

    get isArchived() {
        return this.status == 2;
    }
}

